import EventService from "@/services/EventService.js";
//import * as Sentry from "@sentry/browser";


export const state = {
  user: {},
};
export const mutations = { 
  ADD_USER(state, user) {
    state.user = user;
    EventService.setAuthorization(user.access_token);
  },
  REINSTATE_USER(state, user) {
    EventService.setAuthorization(user.access_token);
  },
  CHANGE_USER_PROFILE_PICTURE(state, image) {
    state.user.imageurl = image;
  },
  REMOVE_USER(state) {
    state.user = {};
  },
  LOGOUT() {},
};
export const actions = {
  logIn({ commit, dispatch }, credentials) {
    let credString =
      "grant_type=password&username=" +
      credentials.email +
      "&password=" +
      credentials.password;
    return EventService.token(credString).then((user) => {
      let data = user.data;
      commit("ADD_USER", data);
      return data;
      //set sentry user
      // Sentry.configureScope(function(scope) {
      //   scope.setTag("my-tag", "my value");
      //   scope.setUser({
      //     id: 10,
      //     email: credentials.email,
      //   });
     // });

    });
    //   .catch(e => {
    //     alert("Invalid username or password");
    //   });
    // throw e; 
  },
  refreshTokenAutomatic({ commit, dispatch}, refreshToken) {
      let credString =
      `grant_type=refresh_token&refresh_token=${refreshToken}`
      return EventService.refreshUsersToken(credString).then((user) => {
        let data = user.data;
     //   localStorage.setItem("user", JSON.stringify(data));
       commit("ADD_USER", data);
        //set sentry user
        // Sentry.configureScope(function(scope) {
        //   scope.setTag("my-tag", "my value");
        //   scope.setUser({
        //     id: 10,
        //     email: data.userName,
        //   });
        // });
      });
     
     
  },
  loggedIn({ commit }, user) {
    commit("REINSTATE_USER", user);
  },
  // the admin gets the different user's object, sends it in here with a parameter, then we commit ADD_USER
  // which will overwrite the current user object to the new user object and sets the autorization to the new
  // token. so now the admin is completely recognized as the other user.
  adminLoginAsDifferentUser({ commit }, user){
    commit("ADD_USER", user);
  },
  logout({ commit }) {
    commit("REMOVE_USER");
    EventService.logOut();
  },
  changeprofilepicture({ commit }, image) {
    commit("CHANGE_USER_PROFILE_PICTURE", image);
  },
};
